type DurationUnit = 'seconds' | 'minutes' | 'hours'

export function durationInMs(value: number, unit: DurationUnit = 'minutes'): number {
  const factors: Record<DurationUnit, number> = {
    seconds: 1000,
    minutes: 60 * 1000,
    hours: 60 * 60 * 1000
  }

  return value * factors[unit]
}
